import { render } from "./UserRoadmap.vue?vue&type=template&id=a6f8f908"
import script from "./UserRoadmap.vue?vue&type=script&lang=ts"
export * from "./UserRoadmap.vue?vue&type=script&lang=ts"
script.render = render

export default script